import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { AWS_BUCKET_URL, TopSports, OtherSports } from 'toolkit/constants';
import BlackBox from 'components/general/black_box.js';
import { calculateSportCount } from 'toolkit/constants';
import SportListItem from 'components/sport/sport_list_item';
import { useAllowedSports } from 'toolkit/useHooks/useAllowedSports';
import {
  fetchOutrightsMarketCount,
  selectOutrightsMarketCount
} from 'stores/outrights';

function Sport() {
  const { t } = useTranslation('translations');
  const dispatch = useDispatch();
  const counts = useSelector((state) => state.match.counts);
  const outrightsCount = useSelector(selectOutrightsMarketCount);
  const { isSportNameAllowed } = useAllowedSports();
  const listItems = [
    {
      items: TopSports,
      title: t('popularsports')
    },
    {
      items: OtherSports,
      title: t('othersports')
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchOutrightsMarketCount());
  }, [dispatch]);

  return (
    <section className="py-2">
      <Container>
        <div className="row g-3 mb-3">
          <div className="col-4">
            <BlackBox
              to="/sport-details?time=Next 4 Hours&show=true"
              icon={`${AWS_BUCKET_URL}/Icons/sandwatchicon.svg`}
              text1={t('pages.sport.next')}
              text2={t('pages.sport.4Hours')}
            />
          </div>
          <div className="col-4">
            <BlackBox
              to="/sport-details?time=Today&show=true"
              icon={`${AWS_BUCKET_URL}/Icons/todayicon.svg`}
              text2={t('today')}
            />
          </div>
          <div className="col-4">
            <BlackBox
              to="/sport-details?time=Tomorrow&show=true"
              icon={`${AWS_BUCKET_URL}/Icons/todayicon.svg`}
              text2={t('tomorrow')}
            />
          </div>
          <div className="col-4">
            <BlackBox
              to="/sport-details?time=Upcoming Live Matches&show=true"
              icon={`${AWS_BUCKET_URL}/Icons/todayicon.svg`}
              text1={t('pages.sport.upcoming')}
              text2={t('pages.sport.liveMatches')}
            />
          </div>
          <div className="col-4">
            <BlackBox
              to="/sport-details?time=Weekend&show=true"
              icon={`${AWS_BUCKET_URL}/Icons/todayicon.svg`}
              text2={t('weekend')}
            />
          </div>
          <div className="col-4">
            <BlackBox
              to="/maradona-handicap"
              icon={`${AWS_BUCKET_URL}/Icons/football.svg`}
              text1={t('pages.start.titleMaradonaHandicap')}
            />
          </div>
        </div>
        {listItems.map((listItem, index) => {
          const isPopular = listItem.title === t('popularsports');
          const outrightsSvgDataUrl =
            "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 24 24' fill='none'><path d='M6 21V11M12 21V6M18 21v-7' stroke='black' stroke-width='1.8' stroke-linecap='round'/><path d='M4 4l3 3 4-4 4 4 5-5' stroke='black' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' fill='none'/><circle cx='20' cy='2' r='1.6' fill='black'/></svg>";
          return (
            <div key={index}>
              <h6 className="sporTitle">{listItem.title}</h6>
              <div className="">
                {isPopular && (
                  <SportListItem
                    key="outrights-row"
                    to="/outrights"
                    text={t('outrights.label')}
                    count={outrightsCount}
                    iconUrl={outrightsSvgDataUrl}
                  />
                )}
                {listItem.items
                  .filter((sportType) => isSportNameAllowed(sportType) && counts[sportType] && Object.keys(counts[sportType]).length)
                  .map((sportType) => (
                    <SportListItem
                      key={sportType}
                      to={`/sport-details/${sportType}`}
                      text={t(`sportType.${sportType}`)}
                      count={calculateSportCount(counts, sportType)}
                      icon={sportType.toLowerCase()}
                    />
                  ))}
              </div>
            </div>
          );
        })}
      </Container>
    </section>
  );
}
export default Sport;
